<template>
    <div class="row" v-if="isLoading">
        <div class="col">
            <card>
                 <span slot="header">
                  </span>
                <h1 class="text-center"><span><font-awesome-icon :icon="['fal','spinner-third']" spin></font-awesome-icon></span></h1>
                <div slot="footer">
                </div>
            </card>
        </div>

    </div>
    <line-chart v-else="!isLoading" :chart-data="chartdata" :extra-options="options"></line-chart>
</template>

<script>

    import moment from 'moment';
    import LineChart from "../Charts/LineChart.js";

    export default {
        name: "CDRGraph",
        components: {
            LineChart,
        },
        data() {
            return {
                chartdata: null,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips:{
                        intersect: false,
                        position: 'nearest',
                        mode: 'index',
                    }
                }
            };
        },
        computed: {
            internalYear() {
                return this.$store.getters['cdrs/internalYear'];
            },
            externalYear() {
                return this.$store.getters['cdrs/externalYear'];
            },
            cdrs() {
                return this.$store.getters['cdrs/CDRS'];
            },
            isLoading() {
                return this.$store.getters['cdrs/isLoading'];
            }
        },
        methods: {
            getPast12Months() {
                return [
                    moment().subtract(10, 'months').format('MMMM'),
                    moment().subtract(9, 'months').format('MMMM'),
                    moment().subtract(8, 'months').format('MMMM'),
                    moment().subtract(7, 'months').format('MMMM'),
                    moment().subtract(6, 'months').format('MMMM'),
                    moment().subtract(5, 'months').format('MMMM'),
                    moment().subtract(4, 'months').format('MMMM'),
                    moment().subtract(3, 'months').format('MMMM'),
                    moment().subtract(2, 'months').format('MMMM'),
                    moment().subtract(1, 'months').format('MMMM'),
                    moment().format('MMMM'),
                ]
            },
            fillChartdata() {
                this.chartdata = {
                    labels: this.getPast12Months(),
                    datasets: [
                        {
                            label: 'Internal',
                            backgroundColor: 'rgba(60,158,59,0.2)',
                            borderColor: 'rgba(60,158,59,.8)',
                            data: this.getInternalCallDataPast12Months(),
                        },
                        {
                            label: 'External',
                            backgroundColor: 'rgba(158,13,22,0.2)',
                            borderColor: 'rgba(158,13,22,.8)',
                            data: this.getExternalCallDataPast12Months(),
                        }
                    ]
                }
            },
            getInternalCallDataPast12Months() {
                let permonth = [];

                this.internalYear.forEach((cdr, index) => {
                    let indx = index;
                    if (!permonth[indx]) {
                        permonth[indx] = []
                    }
                    permonth[indx].push(cdr.count);
                });


                return permonth;
            },
            getExternalCallDataPast12Months() {
                let permonth = [];

                this.externalYear.forEach((cdr, index) => {
                    let indx = index;
                    if (!permonth[indx]) {
                        permonth[indx] = []
                    }
                    permonth[indx].push(cdr.count);
                });


                return permonth;
            }

        },

        mounted() {
            this.$store.dispatch('cdrs/loadInternalYear').then(() => {
                this.fillChartdata();
            });
            this.$store.dispatch('cdrs/loadExternalYear').then(() => {
                this.fillChartdata();
            });
        }
    }
</script>

<style scoped>

</style>